// extracted by mini-css-extract-plugin
export default {"container":"DelayStatistics_container__nlGso","label":"DelayStatistics_label__nzeQ0","contentArea":"DelayStatistics_contentArea__bh0Xf","line":"DelayStatistics_line__mPKh3"};